import React from 'react';

import type { SimpleObject } from '@clearverify/types';

import type { ModalsContextType, ModalsState } from './ModalsContext';
import { ModalsContext } from './ModalsContext';

export const ModalsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [state, setState] = React.useState<ModalsState<SimpleObject>>({});

  const openModal: ModalsContextType['openModal'] = React.useCallback((id, args) => {
    setState(prevState => {
      return {
        ...prevState,
        [id]: {
          isOpen: true,
          args: args || null,
        },
      };
    });
  }, []);

  const closeModal: ModalsContextType['closeModal'] = React.useCallback(id => {
    setState(prevState => {
      return {
        ...prevState,
        [id]: {
          args: { ...prevState[id]?.args },
          isOpen: false,
        },
      };
    });
  }, []);

  const resetState: ModalsContextType['resetState'] = React.useCallback(() => {
    setState({});
  }, []);

  const contextValue: ModalsContextType = React.useMemo(() => {
    return { state, openModal, closeModal, resetState };
  }, [closeModal, openModal, resetState, state]);

  return <ModalsContext value={contextValue}>{children}</ModalsContext>;
};
